/* eslint-disable object-shorthand */
/* eslint-disable import/no-duplicates */
import _ai_color_robot from '@/pages/home/assets/svg/common/ai-color-robot.svg';
import _android from '@/pages/home/assets/svg/dashboard/android.svg';
import _android_green from '@/pages/home/assets/svg/dashboard/android-green.svg';
import _appannie from '@/pages/home/assets/svg/dashboard/appannie.svg';
import _appstore from '@/pages/home/assets/svg/dashboard/appstore.svg';
import _arrow from '@/pages/home/assets/svg/dashboard/arrow.svg';
import _arrow_right from '@/pages/home/assets/svg/dashboard/arrow-right.svg';
import _avatar_default_copy from '@/pages/home/assets/svg/dashboard/avatar-default copy.svg';
import _avatar_default from '@/pages/home/assets/svg/dashboard/avatar-default.svg';
import _blue from '@/pages/home/assets/svg/dashboard/blue.svg';
import _change from '@/pages/home/assets/svg/dashboard/change.svg';
import _change_hover from '@/pages/home/assets/svg/dashboard/change-hover.svg';
import _change_locale_ch from '@/pages/home/assets/svg/dashboard/change-locale-ch.svg';
import _change_locale_en from '@/pages/home/assets/svg/dashboard/change-locale-en.svg';
import _change_white from '@/pages/home/assets/svg/dashboard/change-white.svg';
import _clear_icon from '@/pages/home/assets/svg/dashboard/clear-icon.svg';
import _clock from '@/pages/home/assets/svg/dashboard/clock.svg';
import _company from '@/pages/home/assets/svg/dashboard/company.svg';
import _company_default from '@/pages/home/assets/svg/dashboard/company-default.svg';
import _comparison_analysis from '@/pages/home/assets/svg/dashboard/comparison-analysis.svg';
import _comparison_analysis_hl from '@/pages/home/assets/svg/dashboard/comparison-analysis-hl.svg';
import _competitor from '@/pages/home/assets/svg/dashboard/competitor.svg';
import _competitor_hl from '@/pages/home/assets/svg/dashboard/competitor-hl.svg';
import _config from '@/pages/home/assets/svg/dashboard/config.svg';
import _config_active from '@/pages/home/assets/svg/dashboard/config-active.svg';
import _console from '@/pages/home/assets/svg/dashboard/console.svg';
import _console_game_default from '@/pages/home/assets/svg/dashboard/console-game-default.svg';
import _custom from '@/pages/home/assets/svg/dashboard/custom.svg';
import _custom_hover from '@/pages/home/assets/svg/dashboard/custom_hover.svg';
import _customized_report from '@/pages/home/assets/svg/dashboard/customized-report.svg';
import _customized_report_hl from '@/pages/home/assets/svg/dashboard/customized-report-hl.svg';
import _database from '@/pages/home/assets/svg/dashboard/database.svg';
import _databrainaccount from '@/pages/home/assets/svg/dashboard/databrainaccount.svg';
import _datasheet from '@/pages/home/assets/svg/dashboard/datasheet.svg';
import _detail from '@/pages/home/assets/svg/dashboard/detail.svg';
import _download from '@/pages/home/assets/svg/dashboard/download.svg';
import _effective from '@/pages/home/assets/svg/dashboard/effective.svg';
import _effective_active from '@/pages/home/assets/svg/dashboard/effective-active.svg';
import _email_report from '@/pages/home/assets/svg/dashboard/email-report.svg';
import _email_report_hl from '@/pages/home/assets/svg/dashboard/email-report-hl.svg';
import _engagement from '@/pages/home/assets/svg/dashboard/engagement.svg';
import _engagement_hl from '@/pages/home/assets/svg/dashboard/engagement-hl.svg';
import _enterprise_wechat from '@/pages/home/assets/svg/dashboard/enterprise-wechat.svg';
import _error from '@/pages/home/assets/svg/dashboard/error.svg';
import _exchange from '@/pages/home/assets/svg/dashboard/exchange.svg';
import _expand from '@/pages/home/assets/svg/dashboard/expand.svg';
import _expand_active from '@/pages/home/assets/svg/dashboard/expand-active.svg';
import _favarite from '@/pages/home/assets/svg/dashboard/favarite.svg';
import _favorite from '@/pages/home/assets/svg/dashboard/favorite.svg';
import _favorites from '@/pages/home/assets/svg/dashboard/favorites.svg';
import _favorites_hl from '@/pages/home/assets/svg/dashboard/favorites-hl.svg';
import _feedback from '@/pages/home/assets/svg/dashboard/feedback.svg';
import _fold from '@/pages/home/assets/svg/dashboard/fold.svg';
import _fold_active from '@/pages/home/assets/svg/dashboard/fold-active.svg';
import _gameerror from '@/pages/home/assets/svg/dashboard/gameerror.svg';
import _googleplay from '@/pages/home/assets/svg/dashboard/googleplay.svg';
import _greenarrow from '@/pages/home/assets/svg/dashboard/greenarrow.svg';
import _hatchet from '@/pages/home/assets/svg/dashboard/hatchet.svg';
import _hide_data_tag from '@/pages/home/assets/svg/dashboard/hide-data-tag.svg';
import _imgoppo from '@/pages/home/assets/svg/dashboard/imgoppo.png';
import _imgoppo2 from '@/pages/home/assets/svg/dashboard/imgoppo2.png';
import _imgoppo3 from '@/pages/home/assets/svg/dashboard/imgoppo3.png';
import _imgoppo4 from '@/pages/home/assets/svg/dashboard/imgoppo4.png';
import _imgoppo5 from '@/pages/home/assets/svg/dashboard/imgoppo5.png';
import _imgoppo6 from '@/pages/home/assets/svg/dashboard/imgoppo6.png';
import _intelligence_meun_triangle from '@/pages/home/assets/svg/dashboard/intelligence_meun_triangle.svg';
import _intelligence_meun_user from '@/pages/home/assets/svg/dashboard/intelligence_meun_user.svg';
import _introduction from '@/pages/home/assets/svg/dashboard/introduction.svg';
import _introduction2 from '@/pages/home/assets/svg/dashboard/introduction2.svg';
import _ios from '@/pages/home/assets/svg/dashboard/ios.svg';
import _labs from '@/pages/home/assets/svg/dashboard/labs.svg';
import _labs2 from '@/pages/home/assets/svg/dashboard/labs2.svg';
import _level_infinite from '@/pages/home/assets/svg/dataSource/level-infinite.svg';
import _gtdr from '@/pages/home/assets/svg/dataSource/gtdr.svg';
import _lock_close from '@/pages/home/assets/svg/dashboard/lock-close.svg';
import _lock_open from '@/pages/home/assets/svg/dashboard/lock-open.svg';
import _loginwz from '@/pages/home/assets/svg/dashboard/loginwz.svg';
import _logo_ppdesign from '@/pages/home/assets/svg/dashboard/logo-ppdesign.svg';
import _markets from '@/pages/home/assets/svg/dashboard/markets.svg';
import _markets2 from '@/pages/home/assets/svg/dashboard/markets2.svg';
import _menu_config from '@/pages/home/assets/svg/dashboard/menu-config.svg';
import _menu_config_active from '@/pages/home/assets/svg/dashboard/menu-config-active.svg';
import _menu_effective from '@/pages/home/assets/svg/dashboard/menu-effective.svg';
import _menu_effective_active from '@/pages/home/assets/svg/dashboard/menu-effective-active.svg';
import _menu_rule from '@/pages/home/assets/svg/dashboard/menu-rule.svg';
import _menu_rule_active from '@/pages/home/assets/svg/dashboard/menu-rule-active.svg';
import _menu_user from '@/pages/home/assets/svg/dashboard/menu-user.svg';
import _menu_user_active from '@/pages/home/assets/svg/dashboard/menu-user-active.svg';
import _mobile from '@/pages/home/assets/svg/dashboard/mobile.svg';
import _mobile_game_default from '@/pages/home/assets/svg/dashboard/mobile-game-default.svg';
import _monetization from '@/pages/home/assets/svg/dashboard/monetization.svg';
import _monetization_hl from '@/pages/home/assets/svg/dashboard/monetization-hl.svg';
import _multi_timezone from '@/pages/home/assets/svg/dashboard/multi-timezone.svg';
import _multi_timezone_hl from '@/pages/home/assets/svg/dashboard/multi-timezone-hl.svg';
import _oa from '@/pages/home/assets/svg/dashboard/oa.svg';
import _ogdb from '@/pages/home/assets/svg/dashboard/ogdb.svg';
import _overview from '@/pages/home/assets/svg/dashboard/overview.svg';
import _overview_hl from '@/pages/home/assets/svg/dashboard/overview-hl.svg';
import _pc from '@/pages/home/assets/svg/dashboard/pc.svg';
import _pc_game_default from '@/pages/home/assets/svg/dashboard/pc-game-default.svg';
import _qq from '@/pages/home/assets/svg/dashboard/qq.svg';
import _qq_active from '@/pages/home/assets/svg/dashboard/qq-active.svg';
import _qqlogin from '@/pages/home/assets/svg/dashboard/qqlogin.svg';
import _real_time from '@/pages/home/assets/svg/dashboard/real-time.svg';
import _real_time_hl from '@/pages/home/assets/svg/dashboard/real-time-hl.svg';
import _redarrow from '@/pages/home/assets/svg/dashboard/redarrow.svg';
import _refresh from '@/pages/home/assets/svg/dashboard/refresh.svg';
import _revenue from '@/pages/home/assets/svg/dashboard/revenue.svg';
import _revenue_hl from '@/pages/home/assets/svg/dashboard/revenue-hl.svg';
import _rule from '@/pages/home/assets/svg/dashboard/rule.svg';
import _rule_active from '@/pages/home/assets/svg/dashboard/rule-active.svg';
import _search from '@/pages/home/assets/svg/dashboard/search.svg';
import _search2 from '@/pages/home/assets/svg/dashboard/search2.svg';
import _show_data_tag from '@/pages/home/assets/svg/dashboard/show-data-tag.svg';
import _teaoa from '@/pages/home/assets/svg/dashboard/teaoa.svg';
import _topcharts from '@/pages/home/assets/svg/dashboard/topcharts.svg';
import _topcharts2 from '@/pages/home/assets/svg/dashboard/topcharts2.svg';
import _trend_down from '@/pages/home/assets/svg/dashboard/trend-down.svg';
import _trends from '@/pages/home/assets/svg/dashboard/trends.svg';
import _trends2 from '@/pages/home/assets/svg/dashboard/trends2.svg';
import _trend_up from '@/pages/home/assets/svg/dashboard/trend-up.svg';
import _triangle from '@/pages/home/assets/svg/dashboard/triangle.svg';
import _triangle_hl from '@/pages/home/assets/svg/dashboard/triangle-hl.svg';
import _ua from '@/pages/home/assets/svg/dashboard/ua.svg';
import _ua_hl from '@/pages/home/assets/svg/dashboard/ua-hl.svg';
import _user from '@/pages/home/assets/svg/dashboard/user.svg';
import _user_active from '@/pages/home/assets/svg/dashboard/user-active.svg';
import _vodel from '@/pages/home/assets/svg/dashboard/vodel.svg';
import _vs from '@/pages/home/assets/svg/dashboard/vs.svg';
import _workbench from '@/pages/home/assets/svg/dashboard/workbench.svg';
import _workbench2 from '@/pages/home/assets/svg/dashboard/workbench2.svg';
import _zhuanhuanbingzhuangtu from '@/pages/home/assets/svg/dashboard/zhuanhuanbingzhuangtu.svg';
import _zhuanhuanbingzhuangtu2 from '@/pages/home/assets/svg/dashboard/zhuanhuanbingzhuangtu2.svg';
import _zhuanhuanxianxingtu from '@/pages/home/assets/svg/dashboard/zhuanhuanxianxingtu.svg';
import _zhuanhuanxianxingtu2 from '@/pages/home/assets/svg/dashboard/zhuanhuanxianxingtu2.svg';
import _zhuanhuanzhuxhuangtu from '@/pages/home/assets/svg/dashboard/zhuanhuanzhuxhuangtu.svg';
import _zhuanhuanzhuxhuangtu2 from '@/pages/home/assets/svg/dashboard/zhuanhuanzhuxhuangtu2.svg';

import _avatar from '@/pages/home/assets/img/dashboard/avatar.png';
import _country from '@/pages/home/assets/img/dashboard/country.png';
import _drawer from '@/pages/home/assets/img/dashboard/drawer.png';
import _germany from '@/pages/home/assets/img/dashboard/germany.png';
import _italy from '@/pages/home/assets/img/dashboard/italy.png';
import _papua_new_guinea from '@/pages/home/assets/img/dashboard/papua-new-guinea.png';
import _turkey from '@/pages/home/assets/img/dashboard/turkey.png';
import _united_arab_emirates from '@/pages/home/assets/img/dashboard/united-arab-emirates.png';

import _no_data from '@/pages/home/assets/img/no-data.png';
import _erweima from '@/pages/home/assets/img/erweima.png';
// import _header_bg from '@/pages/home/assets/img/header-bg.jpg';
import _login_bg from '@/pages/home/assets/img/login-bg.png';
import _login_logo from '@/pages/home/assets/img/login-logo.svg';
import _logo from '@/pages/home/assets/img/logo.svg';
import _dark_logo from '@/pages/home/assets/img/dark-logo.svg';

// 有重名，统一在后面加下划线_ 作区分
import _appannie_ from '@/pages/home/assets/svg/dataSource/appannie.svg';
import _appstore_ from '@/pages/home/assets/svg/dataSource/appstore.svg';
import _bilibili_ from '@/pages/home/assets/svg/dataSource/bilibili.svg';
import _crunchbase_ from '@/pages/home/assets/svg/dataSource/crunchbase.svg';
import _databarin_ from '@/pages/home/assets/svg/dataSource/databarin.svg';
import _epic_ from '@/pages/home/assets/svg/dataSource/theme-icon/epic-theme.svg';
import _gog_ from '@/pages/home/assets/svg/dataSource/theme-icon/gog-theme.svg';
import _fbgaming_ from '@/pages/home/assets/svg/dataSource/fbgaming.svg';
import _googleplay_ from '@/pages/home/assets/svg/dataSource/googleplay.svg';
import _hatchet_ from '@/pages/home/assets/svg/dataSource/hatchet.svg';
import _heybox_ from '@/pages/home/assets/svg/dataSource/theme-icon/heybox-theme.svg';
import _hotcool_ from '@/pages/home/assets/svg/dataSource/theme-icon/hotcool-theme.svg';
import _kakao_ from '@/pages/home/assets/svg/dataSource/theme-icon/kakao-theme.svg';
import _poe2_ from '@/pages/home/assets/svg/dataSource/theme-icon/poe2-theme.svg';
import _dltb_official_website from '@/pages/home/assets/svg/dataSource/theme-icon/dltb-official-website.svg';
import _howlongtobeat_ from '@/pages/home/assets/svg/dataSource/howlongtobeat.svg';
import _mscience_ from '@/pages/home/assets/svg/dataSource/mscience.svg';
import _newzoo_ from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import _newzoo_ from '@/pages/home/assets/svg/dataSource/newzoo.svg';
import _nintendo_ from '@/pages/home/assets/svg/dataSource/theme-icon/nintendo-theme.svg';
import _npd_ from '@/pages/home/assets/svg/dataSource/npd.svg';
import _playstation_ from '@/pages/home/assets/svg/dataSource/theme-icon/playstation-theme.svg';
import _sensortower_ from '@/pages/home/assets/svg/dataSource/sensortower.svg';
import _steam_ from '@/pages/home/assets/svg/dataSource/theme-icon/steam-theme.svg';
import _steamblack_ from '@/pages/home/assets/svg/dataSource/steam.svg';
import _steamicon_ from '@intelligence/assets/svg/dataSource/steam-icon.svg';
import _gsd_ from '@intelligence/assets/svg/dataSource/gsd-icon.svg';
import _gamalytic_ from '@intelligence/assets/svg/dataSource/gamalytic.svg';
import _alinea_ from '@intelligence/assets/svg/dataSource/alinea.svg';
import _taptap_ from '@/pages/home/assets/svg/dataSource/taptap.svg';
import _twitch_ from '@/pages/home/assets/svg/dataSource/twitch.svg';
import _xbox_ from '@/pages/home/assets/svg/dataSource/theme-icon/xbox-theme.svg';
import _youtube_ from '@/pages/home/assets/svg/dataSource/youtube.svg';
import _famitsu from '@/pages/home/assets/svg/dataSource/famitsu.svg';
import _vginsights from '@/pages/home/assets/svg/dataSource/vginsights.svg';
import _ampere from '@/pages/home/assets/svg/dataSource/other-vendor.svg';
import _alinea from '@/pages/intelligence/assets/svg/dataSource/alinea.svg';
import _databrainbluebg from '@/pages/intelligence/assets/svg/dataSource/databrain-blue-bg.svg';
import _amperedau from '@/pages/intelligence/assets/svg/dataSource/ampere.svg';
import _sensortowernew from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import _allcountry from '@/pages/intelligence/assets/svg/dataSource/all-country.svg';
import _igntrailer from '@/pages/home/assets/svg/dashboard/IGN-trailer.svg';

// 系统来源icon补充
import _linux from '@/pages/home/assets/svg/dashboard/linux.svg';
import _mac from '@/pages/home/assets/svg/dashboard/mac.svg';
import _web from '@/pages/home/assets/svg/dashboard/web.svg';
import _windows from '@/pages/home/assets/svg/dashboard/windows.svg';
import _interstitial from '@/pages/home/assets/svg/dashboard/Interstitial.svg';
import _banner from '@/pages/home/assets/svg/dashboard/banner.svg';
import _rewarded from '@/pages/home/assets/svg/dashboard/rewarded.svg';
import _native from '@/pages/home/assets/svg/dashboard/native.svg';
import _app_open from '@/pages/home/assets/svg/dashboard/app-open.svg';

const imgMap : Record<string, string> = {
  '_ai-color-robot': _ai_color_robot,
  '_android': _android,
  '_android_green': _android_green,
  '_appannie': _appannie,
  '_appstore': _appstore,
  '_arrow': _arrow,
  '_arrow-right': _arrow_right,
  '_avatar-default copy': _avatar_default_copy,
  '_avatar-default': _avatar_default,
  '_blue': _blue,
  '_change': _change,
  '_change-hover': _change_hover,
  '_change-locale-ch': _change_locale_ch,
  '_change-locale-en': _change_locale_en,
  '_change-white': _change_white,
  '_clear-icon': _clear_icon,
  '_clock': _clock,
  '_company': _company,
  '_company-default': _company_default,
  '_comparison-analysis': _comparison_analysis,
  '_comparison-analysis-hl': _comparison_analysis_hl,
  '_competitor': _competitor,
  '_competitor-hl': _competitor_hl,
  '_config': _config,
  '_config-active': _config_active,
  '_console': _console,
  '_console-game-default': _console_game_default,
  '_custom': _custom,
  '_custom-hover': _custom_hover,
  '_customized-report': _customized_report,
  '_customized-report-hl': _customized_report_hl,
  '_database': _database,
  '_databrainaccount': _databrainaccount,
  '_datasheet': _datasheet,
  '_detail': _detail,
  '_download': _download,
  '_effective': _effective,
  '_effective-active': _effective_active,
  '_email-report': _email_report,
  '_email-report-hl': _email_report_hl,
  '_engagement': _engagement,
  '_engagement-hl': _engagement_hl,
  '_enterprise_wechat': _enterprise_wechat,
  '_error': _error,
  '_exchange': _exchange,
  '_expand': _expand,
  '_expand-active': _expand_active,
  '_favarite': _favarite,
  '_favorite': _favorite,
  '_favorites': _favorites,
  '_favorites-hl': _favorites_hl,
  '_feedback': _feedback,
  '_fold': _fold,
  '_fold-active': _fold_active,
  '_gameerror': _gameerror,
  '_googleplay': _googleplay,
  '_greenarrow': _greenarrow,
  '_hatchet': _hatchet,
  '_hide-data-tag': _hide_data_tag,
  '_imgoppo': _imgoppo,
  '_imgoppo2': _imgoppo2,
  '_imgoppo3': _imgoppo3,
  '_imgoppo4': _imgoppo4,
  '_imgoppo5': _imgoppo5,
  '_imgoppo6': _imgoppo6,
  '_intelligence-meun-triangle': _intelligence_meun_triangle,
  '_intelligence-meun-user': _intelligence_meun_user,
  '_introduction': _introduction,
  '_introduction2': _introduction2,
  '_ios': _ios,
  '_labs': _labs,
  '_labs2': _labs2,
  '_lock-close': _lock_close,
  '_lock-open': _lock_open,
  '_loginwz': _loginwz,
  '_logo-ppdesign': _logo_ppdesign,
  '_markets': _markets,
  '_markets2': _markets2,
  '_menu-config': _menu_config,
  '_menu-config-active': _menu_config_active,
  '_menu-effective': _menu_effective,
  '_menu-effective-active': _menu_effective_active,
  '_menu-rule': _menu_rule,
  '_menu-rule-active': _menu_rule_active,
  '_menu-user': _menu_user,
  '_menu-user-active': _menu_user_active,
  '_mobile': _mobile,
  '_mobile-game-default': _mobile_game_default,
  '_monetization': _monetization,
  '_monetization-hl': _monetization_hl,
  '_multi-timezone': _multi_timezone,
  '_multi-timezone-hl': _multi_timezone_hl,
  '_oa': _oa,
  '_ogdb': _ogdb,
  '_otdr': _gtdr,
  '_tencentrealdata': _level_infinite,
  '_overview': _overview,
  '_overview-hl': _overview_hl,
  '_pc': _pc,
  '_pc-game-default': _pc_game_default,
  '_qq': _qq,
  '_qq-active': _qq_active,
  '_qqlogin': _qqlogin,
  '_real-time': _real_time,
  '_real-time-hl': _real_time_hl,
  '_redarrow': _redarrow,
  '_refresh': _refresh,
  '_revenue': _revenue,
  '_revenue-hl': _revenue_hl,
  '_rule': _rule,
  '_rule-active': _rule_active,
  '_search': _search,
  '_search2': _search2,
  '_show-data-tag': _show_data_tag,
  '_teaoa': _teaoa,
  '_topcharts': _topcharts,
  '_topcharts2': _topcharts2,
  '_trend-down': _trend_down,
  '_trends': _trends,
  '_trends2': _trends2,
  '_trend-up': _trend_up,
  '_triangle': _triangle,
  '_triangle-hl': _triangle_hl,
  '_ua': _ua,
  '_ua-hl': _ua_hl,
  '_user': _user,
  '_user-active': _user_active,
  '_vodel': _vodel,
  '_vs': _vs,
  '_workbench': _workbench,
  '_workbench2': _workbench2,
  '_zhuanhuanbingzhuangtu': _zhuanhuanbingzhuangtu,
  '_zhuanhuanbingzhuangtu2': _zhuanhuanbingzhuangtu2,
  '_zhuanhuanxianxingtu': _zhuanhuanxianxingtu,
  '_zhuanhuanxianxingtu2': _zhuanhuanxianxingtu2,
  '_zhuanhuanzhuxhuangtu': _zhuanhuanzhuxhuangtu,
  '_zhuanhuanzhuxhuangtu2': _zhuanhuanzhuxhuangtu2,

  '_avatar': _avatar,
  '_country': _country,
  '_drawer': _drawer,
  '_germany': _germany,
  '_italy': _italy,
  '_papua-new-guinea': _papua_new_guinea,
  '_turkey': _turkey,
  '_united-arab-emirates': _united_arab_emirates,

  '_no-data': _no_data,
  '_erweima': _erweima,
  // '_header-bg': _header_bg,
  '_login-bg': _login_bg,
  '_login-logo': _login_logo,
  '_logo': _logo,
  '_dark_logo': _dark_logo,

  // 有重名，统一在后面加下划线_ 作区分
  '_appannie_': _appannie_, // appannie重名
  '_data.ai_': _appannie_, 
  '_appstore_': _appstore_, // appstore重名
  '_bilibili_': _bilibili_,
  '_crunchbase_': _crunchbase_,
  '_databarin_': _databarin_,
  '_epic_': _epic_,
  '_fbgaming_': _fbgaming_,
  '_googleplay_': _googleplay_,
  '_hatchet_': _hatchet_, // hatchet重名
  '_mscience_': _mscience_,
  '_newzoo_': _newzoo_,
  '_nintendo_': _nintendo_,
  '_npd_': _npd_,
  '_playstation_': _playstation_,
  '_sensortower_': _sensortower_,
  '_steam_': _steam_,
  '_steamblack_': _steamblack_,
  '_gsd_': _gsd_,
  '_steamcharts_': _steam_,
  '_taptap_': _taptap_,
  '_twitch_': _twitch_,
  '_xbox_': _xbox_,
  '_youtube_': _youtube_,
  '_famitsu_': _famitsu,
  '_vginsights_': _vginsights,
  '_ampere_': _ampere,
  '_alinea_': _alinea,
  '_databrainbluebg_': _databrainbluebg,
  '_amperedau_': _amperedau,
  '_sensortowernew_': _sensortowernew,
  '_allcountry_': _allcountry,
  '_igntrailer_': _igntrailer,

  // 单前下划线的，也兼容一下
  '_appnnie': _appannie,
  '_data.ai': _appannie, 
  '_bilibili': _bilibili_,
  '_crunchbase': _crunchbase_,
  '_databarin': _databarin_,
  '_databrain': _databarin_,
  '_databrain_': _databarin_,
  '_epic': _epic_,
  '_gog': _gog_,
  /** PC 平台 os_id 与图标兜底（与 os_name_en 不同时仍可取图） */
  '_98': _gog_,
  '_fbgaming': _fbgaming_,
  '_mscience': _mscience_,
  '_heybox': _heybox_,
  '_hotcool': _hotcool_,
  '_hotcool_': _hotcool_,
  '_kakao': _kakao_,
  '_poe2_officialwebsite': _poe2_,
  '_poe2_official website': _poe2_,
  '_poe2_officialwebsite(mac)': _poe2_,
  '_poe2_official website(mac)': _poe2_,
  '_poe2_官网(非mac)': _poe2_,
  '_poe2_官网(mac)': _poe2_,
  '_dl_the_beast_officialwebsite': _dltb_official_website,
  '_dl_the_beast_official website': _dltb_official_website,
  '_dl_the_beast_官网': _dltb_official_website,
  '_dl_officialwebsite': _dltb_official_website,
  '_dl_official website': _dltb_official_website,
  '_dl_官网': _dltb_official_website,
  '_dl2_officialwebsite': _dltb_official_website,
  '_dl2_official website': _dltb_official_website,
  '_dl2_官网': _dltb_official_website,
  '_techland_overview_officialwebsite': _dltb_official_website,
  '_techland_overview_official website': _dltb_official_website,
  '_techland_overview_官网': _dltb_official_website,

  '_newzoo': _newzoo_,
  '_nintendo': _nintendo_,
  '_npd': _npd_,
  '_playstation': _playstation_,
  '_sensortower': _sensortower_,
  '_steam': _steam_,
  '_steammac': _steam_,
  '_steam(非mac)': _steam_,
  '_howlongtobeat': _howlongtobeat_,
  '_steamblack': _steamblack_,
  '_steamicon_': _steamicon_,
  '_steamicon': _steamicon_,
  '_gamalytic': _gamalytic_,
  '_gamalytic_': _gamalytic_,
  '_alinea': _alinea_,
  '_alinea_': _alinea_,
  '_gsd': _gsd_,
  '_steamcharts': _steam_,
  "_stream": _steam_,
  '_taptap': _taptap_,
  '_twitch': _twitch_,
  '_xbox': _xbox_,
  '_youtube': _youtube_,
  '_famitsu': _famitsu,
  '_vginsights': _vginsights,
  '_ampere': _ampere,
  '_alinea': _alinea,
  '_databrainbluebg': _databrainbluebg,
  '_amperedau': _amperedau,
  '_sensortowernew': _sensortowernew,
  '_allcountry': _allcountry,
  '_igntrailer': _igntrailer,

  '_epics': _epic_,
  '_linux': _linux,
  '_mac': _mac,
  '_ps4': _playstation_,
  '_ps5': _playstation_,
  '_switch': _nintendo_,
  '_web': _web,
  '_windows': _windows,
  '_interstitial': _interstitial,
  '_banner': _banner,
  '_rewarded': _rewarded,
  '_native': _native,
  '_appopen': _app_open,
  '_appOpen': _app_open,
  
  /**
 * 数据库没有统一的os id，所以配置icon都是取的full_name
 * 给中文名os配置icon
 */
  '_安卓': _android,
  '_任天堂': _nintendo_,
  '_网络': _web,
  '_网站': _web,

};

/**
 * code: 图片code
 * source：扩展字段外部自定义源，优先从外部取，外部没有，从内部取
 */
export const getImg = (code: string, source?: Record<string, string>) => {
  const imgCode = `_${code?.toLowerCase()?.trim()}`;
  if (!source) {
    source = imgMap;
  }
  return source[imgCode];
};
